export interface ISliceErrorProps {
  code: string, title: string, message: string
}

class SliceError extends Error {
  code: string;
  title: string;

  constructor(props: ISliceErrorProps) {
    super(props.message); // message gets passed to Error base class
    this.code = props.code;
    this.title = props.title;

    // Ensure proper stack trace (especially for TypeScript & Babel)
    Object.setPrototypeOf(this, SliceError.prototype);
  }
}

export default SliceError;
